/* eslint-disable */
export default {
    login_email_label: "Email address",
    login_email_placeholder: "Email address",
    login_password_label: "Password",
    login_password_placeholder: "Password",
    login_forgot_password: "Forgot your password?",
    login_login_button_label: "Login",
    login_registration_successful: "Registration successful. You can login now.",
    login_new_user_title: "Create account",
    login_activate_your_account: "Activate your account",
    login_login_label: "Login",
    login_forgot_my_password_label: "I forgot my password",
    login_all_fields_required: "Please fill in all required fields",
    login_login_failed: "Login failed. Please try again.",
    login_api_general_error: "An error occurred while processing your request. Please try again.",
    login_forgot_password_title: "Forgot password",
    login_forgot_password_description: "Enter your email address and we will send you a link to change your password.",
    login_forgot_password_send: "Send",
    login_forgot_password_email: "Email address",
    login_forgot_password_email_placeholder: "Email address",
    login_forgot_password_email_sent_title: "Within minutes you will receive an email",
    login_forgot_password_email_sent_description: "<ul>\n<li>If you registered with us using this email address, you will receive an email to reset your password at the email address you filled in.</li>\n<li>If you haven’t received an email, please check if you have entered the correct email address or if the email has been filtered as spam.</li>\n<li>Follow the instructions in the reset email to change your password.</li>\n</ul>",
    login_change_password_title: "Change password",
    login_change_password_new_password: "New password",
    login_change_password_new_password_confirm: "Confirm password",
    login_change_password_confirm: "Change",
    login_change_password_passwords_dont_match: "These passwords don't match. Please try again.",
    login_forgot_password_all_fields_required: "Please fill in all required fields",
    login_password_change_successful: "Your password has sucessfully been changed. You can login now.",
    login_forgot_password_confirm_title: "Your password has been changed",
    login_forgot_password_return_to_persona_fit_app_mobile: "Click here to return to the Persona.fit app",
    login_forgot_password_return_to_persona_fit_app_desktop: "Open the Persona.fit app on your mobile to log in",
    login_page_title: "Login",
    login_attempts_exceeded_title: "Login failed.",
    login_attempts_exceeded_text: "Your account has been blocked due to too many failed login attempts. Please try again later.",
    login_two_factor_authentication_invalid_code: "The code entered is incorrect, try again.",
    login_two_factor_authentication_title: "Log in",
    login_two_factor_authentication_label_a: "Fill in the code you have received at",
    login_two_factor_authentication_label_b: ".",
    login_two_factor_authentication_continue: "Continue",
    login_error_password_reset_same_password: "You can not use your current password. Choose a new one.",
    login_select_organisation_page_title: "Select an organisation",
    login_select_organisation_title: "Which organisation you want to open?",
    login_select_organisation_submit: "Open",
    login_select_organisation_subtitle: "You can choose an organisation or a suborganisation.",
    login_switch_organisation_title: "Switch organisation",
    password_rule_min_length: "Password should contain at least 12 characters",
    password_rule_uppercase_count: "Password has at least 1 uppercase character",
    password_rule_lowercase_count: "Password has at least 1 lowercase character",
    password_rule_special_characters_count: "Password has at least 1 special/punctuation character",
    password_rule_digits_count: "Password has at least 1 digit",
    password_rule_passwords_matching: "Password fields match",
    login_reset_password_expired_title: "Link zum Zurücksetzen des Passworts abgelaufen",
    login_reset_password_expired_description: "Ihr Link zum Zurücksetzen Ihres Passworts ist abgelaufen, da er entweder bereits verwendet oder nicht innerhalb von 24 Stunden genutzt wurde. Dieser Link ist nur einmal gültig und verfällt nach 24 Stunden. Sie können über die Schaltfläche unten einen neuen Link anfordern.",
    login_button_request_new_link: "Fordern Sie einen neuen Link an",
    login_reset_password_expired_contact_text: "Wenn das Problem weiterhin besteht",
    login_reset_password_expired_contact_link: "Bitte lassen Sie es uns wissen"
};
